<template>
    <div class="ur-dropdown ur-input" :class="dropdownClass" >
        <div class="ur-dropdown__title" :class="dropdownTitleClass" @click="toggleItem" tabindex="0" @keydown="dropKeydown">
        <!--$ver: v0.2.2
            $hide
        --><slot name="selected" :item="selItem" :getText="getText">
                <div class="ur-dropdown__selected" :title="getText(selItem)"><!--
                        $ver: v0.1.2
                        드랍다운 항목 내부에 위치하는 영역 입니다.
                        #This area is located inside the dropdown item.
                    --><slot name="item-text" :item="selItem" :getText="getText"><span>{{getText(selItem)}}</span></slot>
                </div>
            </slot>
            <ur-icon-wrapper class="ur-dropdown__title-icon">
                <ur-icon class="ur-dropdown__icon" icon="expand_menu" size="10px" :style="caretStyle"/>
            </ur-icon-wrapper>
        </div>
        <div class="ur-dropdown__items" :class="itemsClass" ref="floating" v-ur-attach-root:fit v-click-outside.anchor="toggleItemOuter">
            <div class="ur-dropdown__item" v-for="(item, idx) in items" @click.stop="clickParentItem(item)" :key="idx"
                 :class="[!isItemSelectable(item) ? 'ur-dropdown__item-unselectable' : '', dropdownItemSize]" >
                <div class="ur-dropdown__label" :class="{'ur-dropdown__selected': isSelectedItem(item) }">
                    <span class="line-break"><slot name="item-text" :item="item" :getText="getText">{{getText(item)}}</slot></span>
                    <ur-icon-wrapper v-if="item.childItems" style="width:16px;margin-left:12px;">
                        <ur-icon class="ur-dropdown__label-caret" size="10px">expand_menu</ur-icon>
                    </ur-icon-wrapper>
                </div>

                <div class="ur-dropdown__child-items" v-if="item.childItems" :style="itemsWidth">
                    <div class="ur-dropdown__item ur-dropdown__child-item" v-for="(child, childIndex) in item.childItems" :key="idx + '.' + childIndex"
                         @click.stop="clickItem(child)">
                        <div class="ur-dropdown__label"  :class="{'ur-dropdown__selected': isSelectedItem(child) }">
                            <span class="line-break"><slot name="item-text" :item="child" :getText="getText">{{getText(child)}}</slot></span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div v-if="messageShow" 
             class="ur-dropdown__message ur-validator__message"
             :class="messageClass" :style="$_messageStyle()"><!--glue
        -->{{messageShow}}<!--glue
    --></div>
    </div>
</template>

<script>

import urValidatorMixin from '../../../mixins/urValidator/urValidatorMixin.vue';

const UNSELECT_DROPDOWN_TITLE = "Select";
const DEFAULT_PLACEHOLDER = "Input value";
const DEFAULT_ITEM_TEXT  = "text";
const DEFAULT_ITEM_VALUE = "value";

const NOT_SELECTED = -1;
const NEED_CHECK   = -2;
const KEYCODE = {
    TAB       : 9,
    PAGEUP    : 33,
    PAGEDOWN  : 34,
    END       : 35,
    HOME      : 36,
    UP        : 38,
    DOWN      : 40,
    ESC       : 27,
    ENTER     : 13,
}
// ur-dropdown은 N개의 리스트에서 사용자의 선택에 대한 처리의 용도로 사용할 수 있습니다.
// #The ur-dropdown can be used to handle user selection from N lists.
export default {
    name :"ur-dropdown",
    mixins: [urValidatorMixin],
    inject: {
        urInput: {from:'urInput', default: () => undefined}
    },
    props: {
        // $ver: v0.1.0
        // $tags: IDE
        // 선택가능 목록에 대한 data입니다.
        // Array type으로 전달될 경우 각각의 element는 이름과 값을 가지는 Object형태를 가져야합니다.
        // item-text, item-value의 기본값이 'text', 'value'이므로 {text: 'label', value: 'value'} 형태를 사용할 수 있습니다.
        // #The data for the selectable list.
        // #When passed as an array type, each element must have an Object type with a name and a value.
        // #You can use the form {text: 'label', value: 'value'} because the item-text and item-value defaults to 'text' and 'value'.
        items: {
            type:[Array, Object],
            validator: function(val) {
                return Array.isArray(val);
            },
            default: ()=>[]
        },
        // $ver: v0.1.0
        // $v-model
        // $tags: IDE
        // 드랍다운 리스트의 선택된 값 입니다.
        // #The selected value in the drop-down list.
        value: {
            type:[Object,String,Number]
        },
        // $ver: v0.1.0
        // $default: 'Input value'
        // 아무런 data도 선택되지 않았을 때 기본적으로 출력되는 메시지입니다.
        // #This message is displayed by default when no data is selected.
        placeholder : {type: String},

        // $ver: v0.1.2
        // $default: 'text'
        // items에 전달된 데이터 Object에서 리스트에 출력될 값을 선택하는 key값입니다.
        // 혹은 함수형태로 전달하여 text build를 수행할 수 있습니다.(v0.1.2 추가됨)
        // #The key value that selects the value to be displayed in the list from the data object passed to items.
        // #Alternatively, you can perform a text build by passing it as a function (Added to v0.1.2).
        itemText    : {
            type: [String, Function],
            default: DEFAULT_ITEM_TEXT
        },
        // $ver: v0.1.0
        // $default: 'value'
        // items에 전달된 데이터 Object에서 item선택시 v-model에 전달될 값을 선택하는 key값입니다.
        // #The key value that selects the value to be passed to the v-model when selecting an item from the data object passed to the items.
        itemValue   : {type: String , default: DEFAULT_ITEM_VALUE},

        // $ver: v0.1.0
        // $tags: IDE
        // <em>ur-dropdown</em>컴포넌트가 펼쳐졌을 때 나오는 item리스트의 width를 지정할 수 있습니다. 단위는 px입니다.
        // #You can specify the width of the item list that appears when the <em>ur-dropdown</em> component is expanded. The unit is px.
        itemWidth   : {type: [Number, String] /*px*/},

        // $ver: v1.0.1
        // 멀티레벨에서 2단계 레벨만 선택할 수 있게 하는 속성입니다.
        // #This property allows you to select only the second level in multilevel.
        twoLevelSelect    : {type: Boolean, default: false},

        // $ver: v0.1.0
        // $tags: IDE
        // 상호작용 불가능한 상태를 만듭니다.
        // #Create a non-interactive state.
        disabled    : {type: Boolean, default: false},
        // $ver: v0.1.1
        // 하단에 표시되는 가이드 메시지입니다. 별도의 설정이 없다면 출력되지 않습니다.
        // <em>ur-dropdown</em>은 메시지 출력을 위한 공간을 별도로 점유하지않습니다.
        // 메시지 출력을 원할 경우 공간확보가 필요합니다.
        // #The guide message that appears at the bottom. If there is no setting, no output.
        // #<em>ur-dropdown</em> does not occupy space for message output.
        // #If you want to print the message, you need to make space.
        guideMessage: {type: String, default: undefined},
        // $ver: v0.1.1
        // validate를 통과한 경우 출력되는 메시지입니다.
        // 별도설정이 없다면 가이드 메시지가 출력되거나 아무런 메시지도 출력되지 않습니다.
        // <em>ur-dropdown</em>은 메시지 출력을 위한 공간을 별도로 점유하지않습니다.
        // 메시지 출력을 원할 경우 공간확보가 필요합니다.
        // #The message that is output if validate passes.
        // #If there is no setting, guide message or no message is printed.
        // #<em>ur-dropdown</em> does not occupy space for message output.
        // #If you want to print the message, you need to make space.
        successMessage: {type: String, default: undefined},
        // $ver: v0.1.1
        // 가이드 메시지, 에러메시지, 성공메시지의 스타일을 'heavy', 'light' 두가지 스타일 중 선택할 수 있습니다.
        // #You can select the style of guide message, error message or success message from 'heavy' and 'light'.
        messageStyle: {
            type: String,
            validator: function(value) {
                return ['heavy', 'light'].indexOf(value) !== -1;
            },
            default: 'heavy'
        },
        // $ver: v0.2.0
        // Dropdown의 크기를 결정합니다. String 형으로 small, medium에 대한 IDE 처리를 위해 추가되었습니다.
        //#The size You must enter one of two types: medium or small.
        size      : {type: String, default: undefined},
        // $ver: v0.1.2
        // 기본사이즈의 dropdown 컴포넌트를 사용합니다.
        // #Use the default size dropdown component.
        medium: {
            type: Boolean,
            default: false
        },
        // $ver: v0.1.2
        // $abbr: medium
        md: {
            type:Boolean,
            default: false,
        },
        // $ver: v0.1.2
        // 기본보다 작은 사이즈의 dropdown 컴포넌트를 사용합니다.
        // #Use a smaller dropdown component than the default.
        small: {
            type: Boolean,
            default: false
        },
        // $ver: v0.1.2
        // $abbr: small
        sm: {
            type:Boolean,
            default: false,
        },
        // $ver: v0.2.0
        // 드롭다운의 모양을 결정합니다. String 형으로 border, underline 이라는 값을 가질 수 있습니다.
        // #Express Dropdown as shape such as border, underline.
        // $default: 'border'
        // $tags shape
        shape: { type: String, default: 'border'},
        // $ver: v0.2.0
        // Underline 드롭다운 유형 여부입니다.
        // #Express Dropdown as underline.
        // $default: false
        underline: {type: Boolean, default: false},
        // $ver: v2.1.4
        // keyin으로 아이템 이동 선택 가능 여부입니다.
        // #keyinAble allows to select item by keyin-action
        // $default: false
        keyinAble : {type: Boolean, default: false},

        /* [FROM VALIDATOR] */
        // rules
        // disabled
        // lazy
        // noShake
        /********************/
    },
    data(){
        return {
            default: {
                size: 'medium',
                placeholder: UNSELECT_DROPDOWN_TITLE
            },
            /* [FROM VALIDATOR] */
            // hasError
            // errorMessage
            // showValid
            // shake
            /********************/

            isItemShowing  : false,
        }
    },
    mounted(){
      window.addEventListener('resize', this.resize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
  computed: {
        /* [FROM VALIDATOR] */
        // isValidatable
        // el
        validateTarget() {return this.value;}, // validation setting
        /********************/
        $_size() {
            if(!!this.size) {return this.size}
            if(this.medium || this.md) {return 'medium'}
            if(this.small || this.sm) {return 'small'}
            if(this.urInput) {return this.urInput.size}
            return this.default.size;
        },
        messageShow() {
            if(this.hasError === undefined) {
                return this.guideMessage;
            }
            if (this.hasError === true) {
                return this.errorMessage;
            }
            if (this.hasError === false) {
                return this.successMessage || this.guideMessage;
            }
            return undefined;
        },
        messageClass() {
            return ['ur-dropdown__message--'+this.messageStyle];
        },

        itemsMap() {
            let map = new Map(), me = this;
            buildMap(this.items);
            return map;
            function buildMap(arr) {
                arr.forEach(item => {
                    map.set(me.getValue(item),item);
                    if(item.childItems) {buildMap(item.childItems);}
                });
            }
        },
        selItem() {
            return this.itemsMap.get(this.value);
        },
        hasChildItems() {
            let flag = false;
            this.items.forEach(item => {
                flag = flag || !!item.childItems;
            });
            return flag;
        },
        itemsClass() {
            let clazz = [];
            if(this.hasChildItems) clazz.push("ur-dropdown__items--has-child-items");
            return clazz;
        },
        itemsWidth() {
            let iWidth = this.itemWidth || this.width;
            if(!iWidth) return null;
            return {'width' : this.getNumber(iWidth)+'px'}; /**/
        },
        dropdownClass() {
            return {
                'ur-dropdown--disabled': this.disabled,
                'ur-dropdown--medium': this.$_size === 'medium',
                'ur-dropdown--small': this.$_size === 'small',
                'ur-validator--error': this.hasError === true,
                'ur-validator--valid': this.showValid && this.hasError === false,
                'ur-validator--shake': this.shake
            }
        },
        dropdownItemSize(){
            return {
                'ur-dropdown__item--medium': this.$_size === 'medium',
                'ur-dropdown__item--small': this.$_size === 'small',
            }
        },
        dropdownTitleClass(){
            return (this.underline || this.shape === 'underline')? 'ur-dropdown__title-underline': 'ur-dropdown__title-border';
        },
        caretStyle() {
            let style = {};
            if (this.isItemShowing) {
                style['transform'] = 'rotate(-180deg)';
            }
            style['transition-duration'] = '0.3s';
            return style;
        },
    },
    watch: {
        validateTarget(val) {
            this.validateOnEvent(); // whenever checked value changes, execute validate() if lazy is false
        },
        successMessage: {
            immediate: true,
            handler(val) {
                this.showValid = !!val;
            }
        },
    },
    methods: {
        /* [FROM VALIDATOR] */
        // validate()        --+
        // isValid()         --+-- exposed methods for manual validate control
        // clearValidation() --+
        // validateOnEvent() -> should be set by each component which uses urValidatorMixin
        /********************/

        getText(item)  {
            if(!item) return this.placeholder || this.default.placeholder;
            let itemText = '';
            if(typeof(this.itemText) ==='function') {
                itemText = this.itemText(item);
            } else {
                itemText = item[this.itemText];
            }
            if(itemText === undefined || itemText === null) { return item; }
            else { return itemText; }
        },
        getValue(item) {
            if(!item) return null;
            let itemValue = item[this.itemValue];
            if(itemValue === undefined || itemValue === null) { return item; }
            else { return itemValue; }
        },
        getNumber(str) {
            let v = str;
            if(isNaN(v)) {
                v = v.replace(/[^0-9]/g,"");
            }
            return parseInt(v);
        },
        clickParentItem(item){
            // 선택가능한 아이템만 clickItem 타도록
            if(this.isItemSelectable(item)){
                this.clickItem(item);
            }
        },
        clickItem(item){
            // $ver: v0.1.0
            // $arg: updated v-model value
            // v-model에 설정된값(value)을 업데이트합니다.
            // item-value props의 설정값에 따라 선택된 항목의 item-value key값을 가져옵니다.
            // # update v-model value(checked props).
            this.$emit('input', this.getValue(item));
            this.toggleItem();
        },
        resize(e){
            if(this.$refs.floating.isShow() === true){
              this.$refs.floating.resize(e);
            }
        },
        toggleItem (e) {
            if(this.isItemShowing) {
                this.toggleItemOuter(e);
            } else {
                this.toggleShow(e);
            }
        },
        toggleShow (e) {
            this.$refs.floating.open(e);
            this.isItemShowing = true
            this.$emit('toggle-item', this.isItemShowing);
            //attach-root 들 showing 이벤트 이름 통일
            this.$emit('toggle-floating', this.isItemShowing);
        },
        toggleItemOuter () {
            this.$refs.floating.close();
            this.isItemShowing = false
            this.$emit('toggle-item', this.isItemShowing);
            //attach-root 들 showing 이벤트 이름 통일
            this.$emit('toggle-floating', this.isItemShowing);
        },
        isSelectedItem (item) {
            return this.selItem === item;
        },
        isItemSelectable(item) {
            let hasChild = item && item['childItems'] && item['childItems'].length > 0;
            return !hasChild || !this.twoLevelSelect;
        },
        dropKeydown(e) {
            if(this.keyinAble) {
                let keyCode = e.keyCode, idx, len = this.items.length;
                switch(keyCode) {
                case KEYCODE.PAGEUP:
                case KEYCODE.HOME:
                    this.$emit('input', this.getValue(this.items[0]));
                    break;
                case KEYCODE.PAGEDOWN:
                case KEYCODE.END:
                    this.$emit('input', this.getValue(this.items[len-1]));
                    break;
                case KEYCODE.UP:
                    this.toggleShow(e);
                    idx = this.items.indexOf(this.selItem)-1;
                    if(idx<0) idx = 0
                    this.$emit('input', this.getValue(this.items[idx]));
                    console.log("UP  ",idx, this.items[idx]);
                    break;
                case KEYCODE.DOWN:
                    this.toggleShow(e);
                    idx = this.items.indexOf(this.selItem)+1;
                    if(idx>=len) idx = len-1;
                    this.$emit('input', this.getValue(this.items[idx]));
                    console.log("DOWN",idx, this.items[idx]);
                    break;
                case KEYCODE.ENTER:
                    this.toggleItem(e);
                    break;
                case KEYCODE.TAB:
                case KEYCODE.ESC:
                    this.toggleItemOuter();
                    break;
                }
                e.preventDefault();
            }
        },
    },

}

</script>
